<template>
  <div class="mainContentAdmin" id="weblogCategories">
    <b-overlay :show="status" no-wrap fixed z-index="9999">
      <template v-slot:overlay>
        <div class="d-flex align-items-center">
          <b-spinner small type="grow" variant="dark" class="mx-1"></b-spinner>
          <b-spinner type="grow" variant="dark" class="mx-1"></b-spinner>
          <b-spinner small type="grow" variant="dark" class="mx-1"></b-spinner>
        </div>
      </template>
    </b-overlay>
    <div class="filters d-flex align-items-center" style="gap: 12px">
      <b-button variant="primary" @click="getReport()">گزارش </b-button>
      <!-- <b-button variant="primary" @click="showModal = true">افزودن </b-button> -->
    </div>
    <div v-if="items!=null&&items.length>0" class="mainTable">
       <s-table
                    v-model="items"
                    @showEditModal="showEditModal"
                    
                    @deleteItem="deleteItem"
                    :headers="headers"
                  />
    </div>
    <div v-if="items!=null&&totalPages>1">
 <div id="pagination">
        <pagination @pageChanged="pageChanged" :totalPages="totalPages" :currentPage="currentPage" />

        </div>
    </div>
    <b-modal
      id="categoryModal"
      hide-footer
      ref="categoryModal"
      no-close-on-backdrop
      v-model="showModal"
      @close="resetModal()"
      :title="mode == 'create' ? 'افزودن ' + title : ' مشاهده ' + title"
    >
    <!-- :killButtons="true" -->
      <s-inputs
        :disabled="disabled"
        
        :settings="settings"
        @submit="submit"
        :mode="mode"
        :folderRoute="'testAboutUs'"
        :bigData="bigData"
        :headers="headers"
        
      />
      <!-- <rounded-button
              :class="{ disableButton: disabled }"
              @buttonClicked="ReferenceMessage()"
              :type="'button'"
              :buttonType="'button'"
              :title="
                $cookie.get('ltrTheme')
                  ? 'Reference'
                  : 'ارجاع پيام'
              "
            /> -->
    </b-modal>
   
  </div>
</template>
<script>
import {
  required,
  //minLength,
  //maxLength,
  email
} from "vuelidate/lib/validators";
import pagination from "@/components/front/shared/pagination.vue"
import SInputs from "@/components/admin/shared/sInputs.vue";
import STable from "@/components/admin/shared/sTable.vue";
import adminMixin from "@/libraries/adminController.js"
import { BModal, BButton,BOverlay,BSpinner } from "bootstrap-vue";
import RoundedButton from "@/components/front/shared/roundedButton.vue";
export default {
mixins:[adminMixin],
  components: { SInputs, BModal, BButton, STable,BOverlay,BSpinner,pagination,RoundedButton },
  data() {
    return {
      headers: [
        {
          style: "col-8",
          show_in_table: true,
          placeholder: "نام",
          type: "string",
          multiData: false,
          name: "نام",
          key: "fullName",
          disable:true
        },
        {

          style: "col-4",
          show_in_table: true,
          placeholder: "تاريخ ثبت",
          type: "date",
          multiData: false,
          name: "تاريخ ثبت",
          key: "createDate",
          disable:true
        }, 
        {
          style: "col-6",
          show_in_table: false,
          placeholder: "ایمیل",
          type: "string",
          multiData: false,
          name: "ایمیل",
          key: "email",
          disable:true
        },         
        {
          style: "col-6",
          show_in_table: true,
          placeholder: "شماره تماس",
          type: "string",
          multiData: false,
          name: "شماره تماس",
          key: "phone",
          disable:true
        },
        
        {
          style: "col-6",
          show_in_table: true,
          placeholder: "برای مدیریت",
          type: "boolean",
          multiData: false,
          name: "برای مدیریت",
          key: "forManager",
          disable:true
        },
        {
          style: "col-12",
          show_in_table: false,
          placeholder: "متن پیام",
          type: "description",
          multiData: false,
          name: "متن پیام",
          key: "text",
          disable:true
        },
        {
          style: "col-6",
          show_in_table: false,
          placeholder: "ایمیل ارجاع",
          type: "string",
          multiData: false,
          name: "ایمیل ارجاع",
          key: "emailReference",
          disable:false,
          validations:true
          
        },
        {
          style: "col-4",
          show_in_table: true,
          placeholder: "تاريخ ارجاع",
          type: "date",
          multiData: false,
          name: "تاريخ ارجاع",
          key: "dateReference",
          disable:true
        },
        {
          style: "col-12",
          show_in_table: true,
          placeholder: "",
          type: "setting",
          name: "تنظیمات",
          multiData: false,
          key: "",
          edit: true,
          delete: true,
          editLabel:"مشاهده",
          //editLabel: " ویرایش",
          //modal: true
        //  if :emailReference == null
        }
      ],
      pageSize:10,
      bigData: {
        persian: {},
        english: {},
        both: {}
      },
      title: "تماس با ما",
      editedId: null,
      apiRoute: "ContactUs",
    };
  },
  mounted() {
    if(this.$route.query.page){
      this.currentPage=this.$route.query.page
    }else{

      this.currentPage=1;
    }
      this.loadItems(this.currentPage);
  },
  watch:{
      item(newVal){
          this.bigData = newVal
      }
  },
  methods:{
    getReport() {
      this.$axios
        .get("ContactUs/GetContactUsReports", {
          headers: {
            "Content-Disposition": "attachment; filename=XYZ.xlsx",
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        })
        .then((response) => {
          const temp = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = temp;
          link.setAttribute("download", "file.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },
  //  ReferenceMessage() {
  //     if (this.$v.emailReference.required == false) {
  //       return this.$toast.error("وارد کردن ایمیل ارجاع الزامی است");
  //     }else if (this.$v.emailReference.email == false) {
  //       return this.$toast.error(this.$cookie.get('ltrTheme') ?'Invalid imported email format':"فرمت وارد شده ایمیل نامعتبر است");
  //     }
      
  //     const pack = {
  //       fullName: this.fullName,
  //       email: this.email,
  //       phone: this.mobile,
  //       text: this.text,
  //       emailReference: this.emailReference,
  //       createDate: this.createDate,
  //       forManager:this.forManager
  //     };
  //     this.disabled = true;
  //     this.$axios
  //       .post("ContactUs/ReferenceMessage", JSON.stringify(pack), {
  //         headers: {
  //           // Overwrite Axios's automatically set Content-Type
  //           "Content-Type": "application/json",
  //         },
  //       })
  //       .then(() => {
  //         this.$toast.success("ارجاع شما با موفقیت  ثبت گرديد.");
  //         // this.fullName = "";
  //         // this.text = "";
  //         // this.disabled = false;
  //         // this.email = "";
  //         // this.mobile = "";

  //         // this.showModal = false;
  //       })
  //       .catch((error) => {
  //         this.disabled = false;
  //         let arrayError = error.response.data.message.split("|");
  //         arrayError.forEach((err, index) => {
  //           if (index < 1) {
  //             this.$toast.error(err, {
  //               timeout: 1000 * (index + 4),
  //               pauseOnHover: true,
  //             });
  //           }
  //         });
  //       });
  //   }
},
validations: {

   // emailReference: {
   emailReference:
    {
     required,
     email
    }
 
}
};
</script>
<style></style>
